import React from "react";
import {
  FiPhone,
  FiMapPin,
  FiMail,
  FiClock,
} from "react-icons/fi";
import {
  FaInstagram,
  FaLinkedin,
  FaWhatsapp,
  FaYoutube,
} from "react-icons/fa";

import { DS } from "../../utils/designSystem";

const INFO = [
  {
    icon: FiPhone,
    label: "Phone",
    lines: ["+91 6362 720 677"],
    sub: "Call us anytime",
  },
  {
    icon: FiMail,
    label: "Email",
    lines: ["connect@kodevedic.com"],
    sub: "Drop us a line anytime",
  },
  {
    icon: FiMapPin,
    label: "Address",
    lines: ["RICECITY, Near ZP School, Fulchur", "Gondia, Maharashtra – 441601"],
    sub: null,
  },
  {
    icon: FiClock,
    label: "Hours",
    lines: ["Mon – Sun: 9:00 AM – 7:00 PM"],
    sub: null,
  },
];

const SOCIALS = [
  { icon: FaInstagram, href: "https://www.instagram.com/joinspaf/", label: "Instagram" },
  { icon: FaLinkedin,  href: "https://www.linkedin.com/company/joinspaf/", label: "LinkedIn" },
  { icon: FaWhatsapp,  href: "https://wa.me/916362720677", label: "WhatsApp" },
  { icon: FaYoutube,   href: "https://www.youtube.com/@joinspaf", label: "YouTube" },
];

const ContactDetails = () => {
  return (
    <div className={`${DS.card.base} ${DS.card.pad} flex flex-col gap-7`}>
      {/* Header */}
      <div>
        <h2 className="text-2xl font-bold text-richblack-5">Contact Us</h2>
        <p className={`${DS.text.caption} mt-1`}>
          Reach out - we typically reply within one business day.
        </p>
      </div>

      {/* Info rows */}
      <ul className="flex flex-col gap-5">
        {INFO.map(({ icon: Icon, label, lines, sub }) => (
          <li key={label} className="flex items-start gap-4">
            <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-yellow-50/10 text-yellow-50">
              <Icon className="text-base" />
            </span>
            <div className="min-w-0">
              <p className="text-sm font-semibold text-richblack-5">{label}</p>
              {lines.map((l) => (
                <p key={l} className={DS.text.caption}>{l}</p>
              ))}
              {sub && <p className="mt-0.5 text-xs text-richblack-500">{sub}</p>}
            </div>
          </li>
        ))}
      </ul>

      {/* Map */}
      <div className="overflow-hidden rounded-xl border border-richblack-700">
        <iframe
          title="KodeVedic Location"
          src="https://maps.google.com/maps?q=Gondia+Maharashtra+India&output=embed"
          width="100%"
          height="200"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="block"
        />
      </div>

      {/* Social links */}
      <div>
        <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-richblack-400">
          Follow Us
        </p>
        <div className="flex gap-3">
          {SOCIALS.map(({ icon: Icon, href, label }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noreferrer"
              aria-label={label}
              className="flex h-9 w-9 items-center justify-center rounded-lg border border-richblack-700 text-richblack-300 transition-colors duration-150 hover:border-yellow-50/40 hover:bg-yellow-50/10 hover:text-yellow-50"
            >
              <Icon className="text-base" />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactDetails;
